module.exports = __webpack_public_path__ + "static/20260812_Press_Release_Pricing-2373f03b495da1df5c570ff3434d020e.pdf";